'use strict';

const Reflux = require('@muzzylane/reflux');
const CaptchaActions = require('../actions/CaptchaActions');

let loaded = false;
let permFailed = false;

const CaptchaStore = Reflux.createStore({
    listenables: [CaptchaActions],

    init: function() {},

    getState: function() {
        return {
            loaded: loaded,
            permFailed: permFailed
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
    },

    onSetScriptLoadedCompleted: function() {
        loaded = true;
        this.emitStatus();
    },

    onSetScriptLoadedFailed: function() {
        //TODO?
        return;
    }
});

module.exports = CaptchaStore;
